import httpClient from '../../../../api/httpClient';
import { LoginRequest, SendEmailRequest } from '../models/auth.interface';
import { CompanySwitchRequestDto } from '../models/company-switch.interface';

async function login(data: LoginRequest) {
  return await httpClient.post('api/auth/login', data);
}

async function register(data: LoginRequest) {
  return await httpClient.post('/api/auth/register', data);
}

async function sendEmail(data: SendEmailRequest) {
  return await httpClient.post('/api/email/send-email', data);
}

async function recoverPassword(data: LoginRequest) {
  return await httpClient.post('/api/auth/recover-password', data);
}

async function switchCompany(data: CompanySwitchRequestDto) {
  return await httpClient.post('api/auth/switch-company', data);
}

async function initiateRegistration(data: { email: string; password: string }) {
  return await httpClient.post('/api/auth/register/initiate', data);
}

async function completeRegistration(data: any) {
  return await httpClient.post('/api/auth/register/complete', data);
}

async function completeRegistrationByEmail(email: string) {
  return await httpClient.post('/api/auth/register/complete-by-email', { email });
}

// Accept invitation prior to completing password setup
async function acceptInvitation(data: { userCompanyId: number | string; otp: number | string }) {
  return await httpClient.post('/api/auth/accept-invitation', data);
}

// Verifica si el usuario main puede crear una nueva empresa (suscripción activa + sin empresa incompleta)
async function checkNewCompanyPrerequisites() {
  return await httpClient.get('/api/company/new-company-check');
}

// Crea una empresa adicional para el usuario main autenticado
async function createAdditionalCompany(): Promise<{ userCompanyId: number; companyId: number }> {
  return await httpClient.post('/api/company/create-additional-company', {});
}

export default {
  login,
  register,
  sendEmail,
  recoverPassword,
  switchCompany,
  initiateRegistration,
  completeRegistration,
  completeRegistrationByEmail,
  acceptInvitation,
  checkNewCompanyPrerequisites,
  createAdditionalCompany,
};
